import { CustomElement } from "@cervval.js/client-html5-core/src/components/customElement.decorator";
import { TypedHtmlElements } from "@cervval.js/client-html5-core/src/components/typedHtmlElements.decorator";
import { WebComponent } from "@cervval.js/client-html5-core/src/components/webComponent";
import { ERROR_MESSAGE_SERVICE, ErrorMessageService, LOG_SERVICE, LogService } from "@cervval.js/common/services";
import { Injected } from "@cervval.js/common/src/dependencies/injected";
import { ErrorWithCode } from "@cervval.js/common/src/errors/errors";
import { I18nType, i18n } from "./i18n/i18n";


@CustomElement({
    name: "cjs-forgotten-password",
    style: require("./forgottenPassword.component.scss"),
    template: require("./forgottenPassword.component.html"),
    i18n
})
export class CjsForgottenPassword extends WebComponent<I18nType> {

    @Injected(LOG_SERVICE, { optional: true })
    protected readonly _log?: LogService;

    @Injected(ERROR_MESSAGE_SERVICE)
    protected readonly _errorMessageService!: ErrorMessageService;

    /** components */
    @TypedHtmlElements()
    private readonly _components!: {
        forgottenPasswordContainer: HTMLDivElement,
        forgottenPasswordTitle: HTMLParagraphElement,
        forgottenPasswordForm: HTMLFormElement,
        emailInput: HTMLInputElement,
        errorMessage: HTMLButtonElement,
        confirmResetButton: HTMLButtonElement
    };

    constructor(
        protected _onPasswordReset: (login: string) => Promise<void>) {
        super();
    }


    /** Init component display */
    public override init(): void {
        this._components.forgottenPasswordTitle.innerText = this.i18n.forgottenPasswordTitle.innerText;
        this._components.confirmResetButton.innerHTML = this.i18n.confirmResetButton.innerHTML;
        this._bindInputActions();
    }

    /**
     * Will call refresh pethod for password input modifications
     */
    private _bindInputActions(): void {
        this._components.forgottenPasswordForm.onsubmit = () => {
            this._clearError();
            this._onPasswordReset(this.emailValue).catch((e: ErrorWithCode) => this._showErrorFromErrorCode(e));
        };
    }

    /**
     * Return the value of the email form input
     */
    private get emailValue(): string {
        return this._components.emailInput.value;
    }

    /**
     * Clear the visible error
     */
    private _clearError(): void {
        this._components.errorMessage.innerText = "";
        this._components.errorMessage.classList.remove("visible");
    }

    /**
     * Display error from the error code
     * @param error error containing the return code
     * @returns 
     */
    private _showErrorFromErrorCode(error: ErrorWithCode): Promise<void> {
        return this._errorMessageService.getErrorMessage(error).then(errorMessage => this._showError(errorMessage));
    }

    /**
     * Display error from a text
     * @param errorMessage 
     */
    private _showError(errorMessage: string): void {
        if (errorMessage) {
            this._components.errorMessage.innerText = errorMessage;
            this._components.errorMessage.classList.add("visible");
        } else {
            this._log?.warn("Trying to show error with empty message");
        }
    }
}